import React, { useEffect, useState } from "react";
import { Input } from "antd";
const CurrencyCosts = (props) => {
  const [value, setValue] = useState("");
  const formatValue = (val) => {
    if (val != null && val !== "") {
      const parseVal = ("" + val).replace(/\$\s?|(,*)/g, "");
      return parseVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "";
  };
  useEffect(() => {
    setValue(formatValue(props.value));
  }, [props.value]);
  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let cleanValue = value.replace(/[^0-9.-]+/g, "");
    const formattedValue = cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    console.log("formattedValue", formattedValue);
    console.log("cleanValue", cleanValue);
    setValue(formattedValue);
    if (props.onChange) {
      event.target.value = formattedValue;
      props.onChange(event);
    }
  };
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Input
        readOnly={props.readOnly}
        className="antD-currency-design"
        addonBefore={"$"}
        placeholder="#,###,###.##"
        value={value}
        onChange={handleInputChange}
      />
    </div>
  );
};
export default CurrencyCosts;
